import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SvgIcon,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '../../../../../../components/Icons';
import { getSignalsListCached } from '../../../../../../stores/signals-main/signals/getters';
import {
  deleteSignalStart,
  renameSignalStart,
} from '../../../../../../stores/signals-main/signals/actions';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiTypography-body1': {
      fontSize: '0.9rem',
      fontWeight: 400,
    },

    '& .MuiListItemIcon-root': {
      minWidth: 40,
      color: 'var(--color-colorPrimary-main)',
    },

    '& .copy-icon': {
      '& path': {
        fill: 'var(--color-colorPrimary-main)',
      },
    },
  },
}));

const ActionMenu = ({ actionMenu = null, original = {}, onClose = {} }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { _id = '' } = original;

  const name = useSelector((state) => {
    const { name = '' } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return name;
  });

  const onRename = () => {
    dispatch(renameSignalStart(_id, name));
    onClose();
  };

  const onDelete = () => {
    dispatch(deleteSignalStart(_id));
    onClose();
  };

  return (
    <Menu
      id="simple-menu"
      anchorEl={actionMenu}
      keepMounted
      open={Boolean(actionMenu)}
      onClose={onClose}
      className={classes.root}
    >
      <MenuItem onClick={onRename}>
        <ListItemIcon>
          <SvgIcon component={EditIcon} fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Rename" />
      </MenuItem>
      <MenuItem onClick={onDelete}>
        <ListItemIcon>
          <SvgIcon component={DeleteIcon} fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Delete" />
      </MenuItem>
    </Menu>
  );
};

export default ActionMenu;
